import { useContext, useState } from 'react'
import { IconButton, TextInput } from 'ui'
import { UGEContext } from '../../../context'
import { getCaptionLayer } from '../../../utilities/layer'
import { Options } from './style'

type Props = {
    className?: string
}

const UGEEditorQuickDecorate = ({ className }: Props) => {
    const { addLayer, dimensions, openEditor, trackGAEvent } = useContext(UGEContext)
    const [text, setText] = useState<string>('')

    async function onStickerClick() {
        if (!text) return

        openEditor('stickers', {
            searchTerm: text,
        })
    }

    function onCaptionClick() {
        if (!text) return

        const layer = getCaptionLayer(text, dimensions)

        addLayer(layer)

        openEditor('captions', {
            layerId: layer.id,
        })

        trackGAEvent('creation_caption_add', {
            creation: {
                assetMenuObject: 'quick decorate',
            },
        })
    }

    return (
        <Options className={className}>
            <TextInput
                autoFocus
                placeholder="Type to decorate"
                size="medium"
                style={{ width: '100%' }}
                value={text}
                onChange={setText}
            />
            <IconButton gradient="blue-green" icon="sticker" inverted size="medium" onClick={onStickerClick} />
            <IconButton gradient="red-pink" icon="text" inverted size="medium" onClick={onCaptionClick} />
        </Options>
    )
}

export default UGEEditorQuickDecorate
